import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./pendingReportAppointmentsPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { useAppSelector } from "../../../services/hooks";
import {
  pendingReportAppointmentsSelector,
  pendingReportInquiriesSelector,
} from "../../../services/selectors/user.selectors";
import { useNavigate } from "react-router-dom";

function PendingReportAppointmentsPopup({ onClose }: IPopupWithoutProps) {
  const pendingReportAppointments = useAppSelector(
    pendingReportAppointmentsSelector
  );
  const pendingReportInquiries = useAppSelector(pendingReportInquiriesSelector);

  const navigate = useNavigate();

  return (
    <article className={popupStyles.popup} data-testid="pending-reports-popup">
      <h2 className={popupStyles.popup__title}>
       {t("PENDING_REPORTS_POPUP_TITLE_PART1")}{" "}
        {pendingReportAppointments.length + pendingReportInquiries.length + " "}
{t("PENDING_REPORTS_POPUP_TITLE_PART2")}      </h2>
      <img
        src={doctor}
       alt={t("IMAGE_ALT_VENCHY_DOCTOR")}
        className={popupStyles.popup__img}
      />
      <button
        type={"button"}
        className={`button button_white hover ${popupStyles.popup__nextBtn}`}
        data-testid="pending-reports-popup-view-button"
        onClick={() => {
          navigate("/pendingReports");
          onClose();
        }}
      >
         {t("PENDING_REPORTS_POPUP_VIEW_BUTTON")}
      </button>
      <button
        type={"button"}
        className={`button hover ${popupStyles.popup__nextBtn}`}
        data-testid="pending-reports-popup-close-button"
        onClick={onClose}
      >
       {t("PENDING_REPORTS_POPUP_CLOSE_BUTTON")}
      </button>
    </article>
  );
}

export default PendingReportAppointmentsPopup;
